import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './shophome.css';
import './styles.css';
import './product.css';
import ProductCard from './ProductCard';
import cartIcon from './media/icons/cart.svg';
import MenuButton from './MenuButton';
import { Product } from './types/Product'; 

interface CartItem {
  id: number;
  quantity: number;
}

const products: Product[] = [
  {
    id: 1,
    name: 'New Era 9Forty Diamond Era “Conglomerator&Co” Snapback',
    description: `- Shipping/Handling\n- Taxes`,
    dimensions: 'One size fits all',
    price: "$100.00",
    priceId: "price_1RZDlACTXHQWQf5M6jZ8gYCZ",
    feature: "Limited Edition",
    images: [
      require('./media/images/conglomeratorco_snapback.JPEG'),
      require('./media/images/conglomeratorco_snapback1.JPEG'),
      require('./media/images/conglomeratorco_snapback2.JPEG'),
      require('./media/images/conglomeratorco_snapback3.JPEG'),
      require('./media/images/conglomeratorco_snapback4.JPEG'),
    ]
  },
  {
    id: 2,
    name: 'Tycoonland Sticker',
    price: "$7.99",
    priceId: "price_1RYpwnCTXHQWQf5MWNGS47eO",
    dimensions: '2.9” x 5”',
    images: [require('./media/images/tycoon_sticker.JPEG')],
  },
  {
    id: 3,
    name: 'Questgrid Icon Sticker',
    price: "$5.00",
    priceId: "price_1RYpwlCTXHQWQf5MWgTD97Bq",
    dimensions: '3.4” x 3.5”',
    images: [require('./media/images/iconsticker.PNG')],
  },
  {
    id: 4,
    name: 'Stockbroker TycoonLand Sticker',
    price: "$7.99",
    priceId: "price_1RYpwjCTXHQWQf5MqMRgt3XV",
    dimensions: '4.2” x 4.2"',
    images: [require('./media/images/stockbrokertycoon_sticker.PNG')],
  },
  {
    id: 5,
    name: 'Questgrid Sticker',
    price:"$5.00",
    priceId: "price_1RYpwfCTXHQWQf5MBxwZm0e3",
    dimensions: '2” x 4.5”',
    images: [require('./media/images/questgridsticker.JPEG')],
  }
];

const ProductPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const product = products.find(p => p.id === Number(id));

  const [imageIndex, setImageIndex] = useState<number>(0);
  const [cartCount, setCartCount] = useState<number>(0);

  const getCartCount = (): number => {
    const cart: CartItem[] = JSON.parse(localStorage.getItem("cart") || "[]");
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  };

  useEffect(() => {
    setCartCount(getCartCount());
  }, []);

  if (!product) return <p>Product not found</p>;

  const nextImage = () => {
    setImageIndex((prev) => (prev + 1) % product.images.length);
  };

  const prevImage = () => {
    setImageIndex((prev) => (prev - 1 + product.images.length) % product.images.length);
  };

  const handleProductClick = (product: Product) => {
    navigate(`/product/${product.id}`);
  };

  const handleBuyNow = () => {
    const existingCart: CartItem[] = JSON.parse(localStorage.getItem("cart") || "[]");
    const existingIndex = existingCart.findIndex(item => item.id === product.id);

    if (existingIndex !== -1) {
      existingCart[existingIndex].quantity += 1;
    } else {
      existingCart.push({ id: product.id, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    navigate(`/checkout?buyNow=${product.id}&quantity=1`);
  };

  const handleAddToCart = () => {
    const cart: CartItem[] = JSON.parse(localStorage.getItem("cart") || "[]");
    const existingIndex = cart.findIndex(item => item.id === product.id);

    if (existingIndex !== -1) {
      cart[existingIndex].quantity += 1;
    } else {
      cart.push({ id: product.id, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    setCartCount(getCartCount());
  };

  return (
    <div>
      <MenuButton />

      <section className="section2" id="marketplace">
        <div className="shop-header">
          <h2
            className="shop-title"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            Tycoonland Shop
          </h2>

          <div className="cart-icon-wrapper" onClick={() => navigate('/checkout')}>
            <img src={cartIcon} alt="Cart" className="cart-icon" />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </div>
        </div>
      </section>

      <section className="section" id="product-detail">
        <h2>{product.name}</h2>
        <div className="product-detail-container">
          <div className="product-image-wrapper">
            <img
              src={product.images[imageIndex]}
              alt={`${product.name} ${imageIndex + 1}`}
              className="product-detail-image"
            />
            {product.images.length > 1 && (
              <>
                <button className="nav-button prev" onClick={prevImage}>&lt;</button>
                <button className="nav-button next" onClick={nextImage}>&gt;</button>
              </>
            )}
          </div>
        </div>

        <div className="product-detail-container">
          <div className="product-detail-info">
            <p><strong>Price:</strong> {product.price}</p>
            <p><strong>Dimensions:</strong> {product.dimensions}</p>
            <p>+ Shipping/Handling</p>
            <p>+ Taxes</p>
            <div className="product-buttons">
              <button onClick={handleAddToCart}>Add to Cart</button>
              <button onClick={handleBuyNow}>Buy Now</button>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="other-products">
        <h3>Other Products</h3>
        <div className="product-grid">
          {products
            .filter(p => p.id !== product.id)
            .map(p => (
              <ProductCard key={p.id} product={p} onClick={handleProductClick} />
            ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductPage;
